<!--
 * @Description: 合作伙伴详情
 * @Author: cxh
 * @Date: 2022-05-24 15:19:34
 * @LastEditTime: 2022-11-25 10:30:59
 * @LastEditors: cxh
-->
<template>
  <dc-layout-main>
    <dc-layout-content>
      <CosViewContent
        header
        :title="data?.customerInfo?.customerName"
        :sellerName="data?.customerInfo?.sellerName"
        customLabel="联系人姓名"
        :customValue="data?.contact?.name"
      >
        <a-tabs v-model:activeKey="activeKey">
          <a-tab-pane key="1" tab="基本信息">
            <baseMessage
              :disabled="true"
              :perfect="true"
              :data="data"
              :type="type"
              :content="['customerInfo', 'business']"
              :permissionPage="permissionBasic"
              view
              :hideOk="true"
            />
          </a-tab-pane>
          <a-tab-pane key="2" tab="联系人">
            <TabsContacts
              appId="cos_lbu"
              :contactRefId="route.query.cosId"
              :permissionPage="permissionConcat"
              :hideOk="true"
            />
          </a-tab-pane>
        </a-tabs>
      </CosViewContent>
    </dc-layout-content>
  </dc-layout-main>
</template>
<script lang="ts" setup>
import { onMounted, ref } from 'vue'
import TabsContacts from '@/components/TabsContacts/index.vue'
import baseMessage from '@/views/yuntuSales/customerCenter/components/baseMessage.vue'
import { potentialDetail } from '@/api/yuntuSales/customerCenter'
import { useRoute } from 'vue-router'
defineProps({
  type: {
    type: String
  }
})
const route = useRoute()
const data = ref({})
// 获取详情
const fetch = () => {
  if (route.query.cosId) {
    potentialDetail(route.query.cosId).then((res) => {
      data.value = res.data
    })
  }
}
onMounted(() => {
  fetch()
})
const permissionBasic = {
  transfer: 'lbu_clients_transfer_btn',
  visitor_add: 'lbu_clients_visitor_add_btn',
  edit: 'lbu_clients_edit_btn'
}
// const permissionFollow = {
//   add: 'lbu_clients_follow_add_btn',
//   edit: 'lbu_clients_follow_edit_btn',
//   del: 'lbu_clients_follow_del_btn'
// }
// const permissionBuss = {
//   add: 'lbu_clients_buss_add_btn',
//   edit: 'lbu_clients_buss_edit_btn',
//   del: 'lbu_clients_buss_del_btn'
// }
const permissionConcat = {
  add: 'lbu_clients_concat_add_btn',
  edit: 'lbu_clients_concat_edit_btn',
  del: 'lbu_clients_concat_del_btn'
}
</script>
<script lang="ts">
export default {
  name: 'LbuClientsView'
}
</script>
<style lang="scss" scoped></style>
